<script setup lang="ts">
import HeadsetDetails from '../HeadsetDetails.vue';
import HeadsetElement from '../elements/HeadsetElement.vue';
import { Device } from '@/device';
import { ISelectionForm } from '@/interfaces/selectionForm.interface';
import { StateMachineEvent, StateMachineSnapshot } from '@/stateMachine';
import { VueformElement } from '@vueform/vueform';
import { Ref, onMounted, ref, toRaw } from 'vue';

const props = defineProps<{
  snapshot: StateMachineSnapshot;
  send: (event: StateMachineEvent) => void;
}>();

const form$: Ref<VueformElement | null> = ref(null);
const headset: Ref<Device | null> = ref(null);

onMounted(() => {
  if (form$.value && props.snapshot.context.selectionForm) {
    form$.value.load(props.snapshot.context.selectionForm, true);
  }
  if (props.snapshot.context.device) {
    headset.value = props.snapshot.context.device;
  }
});

const formOnChanges = async (data: ISelectionForm, _: ISelectionForm, form: VueformElement) => {
  // Force re-validation
  await form.validate();
  if (data.headset && !form.invalid) {
    props.send({
      type: 'headset.selectionForm.update',
      data: data,
    });
  } else {
    props.send({
      type: 'headset.selectionForm.update',
      data: null,
    });
  }
};

const headsetSelected = (device: Device) => {
  headset.value = device;
  props.send({
    type: 'headset.selected',
    data: device,
  });
};
</script>

<template>
  <div class="d-flex h-100">
    <div class="flex-grow-1 d-flex justify-content-center flex-column align-items-center m-3">
      <Vueform ref="form$" :display-errors="false" @change="formOnChanges">
        <HeadsetElement label="Choissisez le casque à installer" name="headset" @headset-selected="headsetSelected" />
        <GroupElement name="setup" :conditions="[['headset', '==', true]]">
          <CheckboxElement
            name="reset"
            label="Reset casque"
            info="Effectue un nettoyage complet du casque avant de lancer la procédure d'installation"
            text="Reset"
          />
        </GroupElement>
      </Vueform>
    </div>
    <div v-if="headset" class="d-flex justify-content-center flex-column align-items-center w-50 m-3">
      <!-- <SelectionSvg /> -->
      <HeadsetDetails :device="toRaw(headset) as Device" />
    </div>
  </div>
</template>

<style scoped></style>
